module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('strong', [_vm._v("Cathy"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("®")])]), _vm._v(" is distributed internationally by Universal Uclick."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_c('strong', [_vm._v("The Wedding of Cathy and Irving")])]), _vm._v(" copyright © 2005 by Cathy Guisewite. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. For permission information, write Andrews McMeel Publishing, an Andrews McMeel Universal company, 1130 Walnut St. Kansas City, Missouri 64106."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("E-ISBN: 978-0-7407-9942-6"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Control Number: 2004115396"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.andrewsmcmeel.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt11"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.ucomics.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ucomics.com")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "crt11"
  }, [_c('strong', [_vm._v("ATTENTION: SCHOOLS AND BUSINESSES")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please write to: Special Sales Department, Andrews McMeel Publishing, 1130 Walnut St. Kansas City, Missouri 64106.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_vm._v("specialsales@amuniversal.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1e93fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740799426_epub_cop_r1.vue
// module id = 69
// module chunks = 0